<template>
  <v-container fluid>
    <v-card :loading="devicesLoading">
      <v-toolbar color="primary" dark>
        Devices
        <v-spacer></v-spacer>
        <v-text-field
          v-model="searchDevices"
          label="Search"
          single-line
          hide-details
          prepend-icon="mdi-magnify"
          clearable
          v-on:input="onQuickFilterChanged()"
        ></v-text-field>
      </v-toolbar>
      <expandedToolbar
        v-if="organizationsButtonShow"
        :newButton="organizationsButtonShow"
        @newButtonClick="newDeviceDialog = true"
      />
      <v-card-text v-if="devices">
        <v-row>
          <v-col style="height: calc(100vh - 230px) !important;" cols="12">
            <ag-grid-vue
              :style="{ width, height }"
              class="ag-theme-alpine"
              :defaultColDef="defaultColDef"
              :columnDefs="columnDefs"
              :rowData="rowData"
              :animateRows="true"
              rowSelection="multiple"
              @grid-ready="onGridReady"
              @cellDoubleClicked="onCellDoubleClick"
            ></ag-grid-vue>
          </v-col>
        </v-row>
        <!-- <v-data-table
          :headers="devicesHeaders"
          :items="devices"
          :search="searchDevices"
          :items-per-page="10"
          item-key="name"
          sort-by="id"
          :sort-desc="true"
          class="elevation-0"
          :loading="devicesLoading"
        >
          <template v-slot:item.battery_level="{ item }">
            <div v-if="item.battery_level">{{item.battery_level}}V</div>
          </template>
          <template v-slot:item.temperature="{ item }">
            <div v-if="item.temperature">{{item.temperature}}&#8451</div>
          </template>
          <template v-slot:item.actions="{ item }">
            <div>
              <v-menu bottom left>
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="openManageDevice(item)">
                    <v-list-item-title>Manage</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </template>
        </v-data-table>-->
      </v-card-text>
    </v-card>
    <v-dialog v-model="manageDeviceDialog" persistent max-width="600px">
      <v-card v-if="applications" tile>
        <v-toolbar color="primary" dark>
          Manage Device
          <v-spacer></v-spacer>
          <v-btn
            color="white"
            icon
            dark
            @click="
              manageDeviceDialog = false;
              deviceFormData = {};
            "
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field v-model="deviceFormData.pcb_id" label="PCB ID"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field v-model="deviceFormData.version" label="Version"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field v-model="deviceFormData.sim" label="SIM"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-textarea v-model="deviceFormData.comment" label="Comment"></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :loading="manageDeviceLoading" @click="saveDevice()" color="success">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="newDeviceDialog" persistent max-width="600px">
      <v-card v-if="applications" tile>
        <v-toolbar color="primary" dark>
          New Device
          <v-spacer></v-spacer>
          <v-btn color="white" icon dark @click="newDeviceDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-select
                  v-model="newDeviceIDData.prefix"
                  :items="applications"
                  :rules="[value => !!value || 'Application is Required.']"
                  item-text="name"
                  item-value="prefix"
                  label="Application"
                  required
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-text-field v-model="deviceFormData.pcb_id" label="PCB ID"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field v-model="deviceFormData.version" label="Version"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field v-model="deviceFormData.sim" label="SIM"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-textarea v-model="deviceFormData.comment" label="Comment"></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :loading="newDeviceLoading" @click="generateNewDevice()" color="success">Create</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="aGGridActionMenu" persistent max-width="300px">
      <v-card tile>
        <v-toolbar color="primary" dark>
          Action Menu
          <v-spacer></v-spacer>
          <v-btn color="white" icon dark @click="updateAGGridActionMenu()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-list dense>
                  <!-- <v-list-item :to="'/dashboard'">
                    <v-list-item-action>
                      <v-icon>mdi-account-box</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>Event Profile</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>-->
                  <v-list-item @click="openManageDevice()">
                    <v-list-item-action>
                      <v-icon>mdi-cogs</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>Manage Device</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item v-if="currentUserData.role === 'superAdmin'" @click="keyRegen()">
                    <v-list-item-action>
                      <v-icon>mdi-refresh</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>Key Regen</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import { mapGetters } from "vuex";
  import AppBar from "@/components/AppBar";
  import agGridActionButton from "@/components/agGridActionButton";
  import expandedToolbar from "@/components/expandedToolbar.vue";
  import { AgGridVue } from "ag-grid-vue";
  import moment from "moment";

  export default {
    components: { AppBar, AgGridVue, agGridActionButton, expandedToolbar },
    computed: {
      ...mapGetters([
        "currentUser",
        "currentUserData",
        "aGGridActionMenu",
        "selectedRowData",
        "devices",
        "devicesLoading",
        "applications",
        "applicationsLoading",
      ]),
    },
    props: {
      source: String,
    },
    data: () => ({
      // Expanded Toolbar
      organizationsButtonShow: false,
      // AG-Grid
      columnDefs: null,
      rowData: null,
      columnApi: null,
      gridApi: null,
      defaultColDef: {
        sortable: true,
        filter: true,
        resizable: true,
        autoHeight: true,
      },
      width: "100%",
      height: "100%",

      drawer: null,
      devicesHeaders: [
        {
          text: "ID",
          align: "left",
          sortable: true,
        },
        { text: "PCB ID", value: "pcb_id", width: "80px" },
        {
          text: "Firmware",
          value: "version",
        },
        {
          text: "SIM",
          value: "sim",
        },
        {
          text: "Battery",
          value: "battery",
        },
        {
          text: "Temperature",
          value: "temp",
        },
        {
          text: "Lat",
          value: "lat",
        },
        {
          text: "Long",
          value: "long",
        },
        {
          text: "Comment",
          value: "comment",
        },
        {
          text: "Created Time",
          value: "created_at",
        },
        {
          text: "Updated Time",
          value: "updated_at",
        },
        {
          text: "Application Name",
          value: "applications_name",
        },
        {
          text: "Application Prefix",
          value: "applications_prefix",
        },
        {
          text: "Organization Name",
          value: "organizations_name",
        },
        {
          text: "Ownership Start",
          value: "ownerships_start_ts",
        },
        {
          text: "Deployment ID",
          value: "deployments_id",
        },
        {
          text: "Deployment Start",
          value: "deployments_start_ts",
        },
        {
          text: "Actions",
          value: "actions",
        },
      ],
      searchDevices: "",
      //New Devices
      newDeviceDialog: false,
      newDeviceIDData: {},
      newDeviceLoading: false,
      //Manage Devices
      manageDeviceDialog: false,
      manageDeviceLoading: false,
      //DeviceFormData
      deviceFormData: {},
    }),
    beforeMount() {
      this.columnDefs = [
        {
          headerName: "Actions",
          field: "actions",
          cellRendererFramework: "agGridActionButton",
        },
        {
          headerName: "ID",
          field: "id",
        },
        {
          headerName: "Device Key",
          field: "k",
        },
        { headerName: "PCB ID", field: "pcb_id" },
        {
          headerName: "Firmware",
          field: "version",
        },
        {
          headerName: "SIM",
          field: "sim",
        },
        {
          headerName: "Battery",
          field: "battery",
          valueFormatter: batteryFormatter,
        },
        {
          headerName: "Temperature",
          field: "temp",
          valueFormatter: temperatureFormatter,
        },
        {
          headerName: "Lat",
          field: "lat",
        },
        {
          headerName: "Long",
          field: "long",
        },
        {
          headerName: "Comment",
          field: "comment",
        },
        {
          headerName: "Created Time",
          field: "created_at",
          valueFormatter: createdAtFormatter,
        },
        {
          headerName: "Updated Time",
          field: "updated_at",
          valueFormatter: updatedAtFormatter,
        },
        {
          headerName: "Application Name",
          field: "applications_name",
        },
        {
          headerName: "Organization Name",
          field: "organizations_name",
        },
        {
          headerName: "Ownership Start",
          field: "ownerships_start_ts",
        },
        {
          headerName: "Deployment ID",
          field: "deployments_id",
        },
        {
          headerName: "Deployment Start",
          field: "deployments_start_ts",
        },
      ];
      this.$store.dispatch("loadDevices").then(() => {
        this.rowData = this.devices;
        var allColumnIds = [];
        this.columnApi.getAllColumns().forEach(function (column) {
          allColumnIds.push(column.colId);
        });
        this.columnApi.autoSizeColumns(allColumnIds, false);
      });
      if (this.aGGridActionMenu == true) {
        this.$store.dispatch("setAGGridActionMenuState", {});
      }
    },
    mounted() {
      this.$store.dispatch("loadApplications");
      if (
        this.currentUserData.role == "superAdmin" ||
        this.currentUserData.role == "appAdmin"
      ) {
        this.organizationsButtonShow = true;
      }
    },
    watch: {
      devices: function (oldDev, newDev) {
        this.rowData = this.devices;
      },
    },
    methods: {
      onQuickFilterChanged() {
        this.gridApi.setQuickFilter(this.searchDevices);
      },
      onGridReady(params) {
        this.gridApi = params.api;
        this.columnApi = params.columnApi;
      },
      autoSizeColumnsAGGRID() {
        // this.gridApi.sizeColumnsToFit();
        var allColumnIds = [];
        this.columnApi.getAllColumns().forEach(function (column) {
          allColumnIds.push(column.colId);
        });
        this.columnApi.autoSizeColumns(allColumnIds, false);
      },
      onCellDoubleClick(cell) {
        this.$store.dispatch("setAGGridActionMenuState", cell.data);
      },
      updateAGGridActionMenu() {
        this.$store.dispatch("setAGGridActionMenuState", {});
      },
      keyRegen() {
        this.$swal({
          title: "Are you sure?",
          text: `Refreshing the Devcice Key will mean the device will have to be Manually have its Device key changed to the new Key`,
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Continue",
          cancelButtonText: "Cancel",
        }).then((value) => {
          if (value.value === true) {
            this.deviceFormData = this.selectedRowData;
            this.updateAGGridActionMenu();
            this.$store
              .dispatch("randomString", { len: 8, chars: "aA#" })
              .then((result) => {
                this.deviceFormData.k = result;
                // this.saveDevice();
                this.$store
                  .dispatch("saveDevice", this.deviceFormData)
                  .then((result) => {
                    this.$swal({
                      title: "Success!",
                      text: `Device was Saved and the new App Key is k: ${this.deviceFormData.k}`,
                      type: "success",
                      confirmButtonText: "Ok",
                    });
                  });
              });
          } else {
            this.aGGridActionMenu = false;
          }
        });
      },
      generateNewDevice() {
        if (this.newDeviceIDData.prefix) {
          this.newDeviceLoading = true;
          // let idNumber;
          let application = this.applications.filter(
            (a) => a.prefix == this.newDeviceIDData.prefix
          );
          application = application[0];
          // let idNumberMultiplier = Math.floor(application.devices / 10);
          // if (idNumberMultiplier == 4) {
          //   idNumber = parseInt(application.devices) + 1;
          // } else {
          //   idNumber = `${"0".repeat(3 - idNumberMultiplier)}${parseInt(
          //     application.devices
          //   ) + 1}`;
          // }
          this.$store
            .dispatch("randomString", { len: 8, chars: "aA#" })
            .then((result) => {
              this.deviceFormData.k = result;
              // this.deviceFormData.id = `${application.prefix}-${idNumber}`;
              this.deviceFormData.applications_id = application.id;
              this.$store
                .dispatch("newDevice", this.deviceFormData)
                .then((result) => {
                  this.newDeviceLoading = false;
                  this.newDeviceDialog = false;
                  this.$swal({
                    title: "Success!",
                    text: `The Device has been Successfully Created. ID: ${result.devices_id}, k: ${this.deviceFormData.k}`,
                    type: "success",
                    confirmButtonText: "Ok",
                  });
                });
            });
        } else {
          this.$swal({
            title: "Whoops!",
            text: "Please select an Application",
            type: "warning",
            cancelButtonText: "Close",
          });
        }
      },
      openManageDevice(device) {
        this.deviceFormData = this.selectedRowData;
        this.updateAGGridActionMenu();
        this.manageDeviceDialog = true;
      },
      saveDevice() {
        this.manageDeviceLoading = true;
        this.$store.dispatch("saveDevice", this.deviceFormData).then((result) => {
          this.manageDeviceLoading = false;
          this.manageDeviceDialog = false;
          this.$swal({
            title: "Success!",
            text: "Device was Saved",
            type: "success",
            confirmButtonText: "Ok",
          });
        });
      },
    },
  };
  window.batteryFormatter = function batteryFormatter(params) {
    if (params.data.battery) {
      return `${params.data.battery}V`;
    } else {
      return "";
    }
  };
  window.temperatureFormatter = function temperatureFormatter(params) {
    if (params.data.temp) {
      return params.data.temp + "°c";
    } else {
      return "";
    }
    return params.data.temp + "°c";
  };
  window.createdAtFormatter = function createdTimeFormatter(params) {
    if (params.data.created_at) {
      return moment
        .utc(params.data.created_at)
        .local()
        .format("MMMM Do YYYY, h:mm:ss a");
    } else {
      return "";
    }
  };
  window.updatedAtFormatter = function createdTimeFormatter(params) {
    if (params.data.updated_at) {
      return moment
        .utc(params.data.updated_at)
        .local()
        .format("MMMM Do YYYY, h:mm:ss a");
    } else {
      return "";
    }
  };
</script>
